
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import Spinner from '../Components/MainScreens/Spinner/Spinner'

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) return <Spinner />
  if (!user) {
    console.log("navigating to login theres no user authentication completed", "loading", loading)
    return <Navigate to="/login" replace /> // returning if not auth user
  }

  return children
}

export default ProtectedRoute
